import {LoadingButton} from '@mui/lab';
import {Box} from '@mui/material';
import dayjs from 'dayjs';
import {useSnackbar} from 'notistack';
import {useState} from 'react';

import API, {getMessagesFromApiError} from '../../../api/axios';
import {apiBaseUrl} from '../../../api/urls';
import {ExportField} from '../../../interfaces/Export';
import {sanitizeFilename, saveFile} from '../../../utils/file';
import {CloseSnackbarAction} from '../../common/CloseSnackbarButton';
import ExportFieldForm from '../../common/ExportFieldForm';
import ModalFixed from '../../common/ModalFixed';
import SnackbarMessages from '../../common/SnackbarMessages';
import {EventsReportData} from '../ConnectView/EventsReport';

interface Props {
  value?: EventsReportData;
  exportFields?: ExportField[];
}

const ObjectsByCommunicationNodeTrackingExportExcel = ({
  value,
  exportFields,
}: Props) => {
  const {enqueueSnackbar} = useSnackbar();
  const [isFetching, setIsFetching] = useState(false);

  const [isOpened, setIsOpened] = useState(false);

  const checkFields = () => {
    setIsOpened(true);
  };

  const fetchData = async (fields: string[]) => {
    setIsOpened(false);
    setIsFetching(true);
    console.log(value);
    console.log(fields);
    console.log('yes');
    try {
      const params = {
        export: 'excel',
        fields,
        commtrac_external_id: value?.commtrac_external_id,
        date_start: value?.params.date_start,
        date_end: value?.params.date_end,
        message_type: value?.params.message_type,
        by_strongest_cn_only: value?.by_strongest_cn_only,
        event_type: value?.event_type,
        asset_type: value?.asset_type,
      };

      const resp = await API.get(`${apiBaseUrl}/communication-node/events`, {
        params,
        responseType: 'blob',
      });
      const dateStart =
        value?.params.date_start ?? dayjs().format('YYYY-MM-DD');
      const dateEnd = value?.params.date_end ?? dayjs().format('YYYY-MM-DD');
      const nodePrefix = value?.node_name
        ? `${sanitizeFilename(value.node_name)}_`
        : '';
      saveFile(resp.data, `${nodePrefix}events_${dateStart}_${dateEnd}.xlsx`);
    } catch (error: any) {
      const messages = getMessagesFromApiError(error, 'STRA_c47ba5f6');
      enqueueSnackbar(<SnackbarMessages messages={messages} />, {
        variant: 'error',
        action: CloseSnackbarAction,
      });
    }
    setIsFetching(false);
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" justifyContent="end">
        <LoadingButton
          fullWidth
          size="large"
          variant="contained"
          loading={isFetching}
          onClick={() => checkFields()}
        >
          Export to Excel
        </LoadingButton>
      </Box>
      <ModalFixed open={isOpened} onClose={() => setIsOpened(false)}>
        <Box
          display="flex"
          flexDirection="column"
          position="relative"
          gap={3}
          p={3}
        >
          <Box display="flex" justifyContent="space-between">
            <Box display="flex" alignItems="center" width="100%" gap={1.5}>
              <ExportFieldForm
                exportFields={exportFields}
                onChange={fetchData}
                close={() => setIsOpened(false)}
                loading={isFetching}
                columns={3}
              ></ExportFieldForm>
            </Box>
          </Box>
        </Box>
      </ModalFixed>
    </Box>
  );
};

export default ObjectsByCommunicationNodeTrackingExportExcel;
